import { levelContentData } from "./LevelContentData.js";
import LevelContent from "./LevelContent.jsx";
import ReaderHome from "./ReaderHome/ReaderHome.jsx";
import MyNotes from "./MyNotes/FundamentalsMyNotes.jsx";
import Packages from "./Packages/Packages.jsx";

export default {
  slug : "fundamentals",
  title: "Trading Fundamentals",
  contentType: "video", 
  levelContentData,
  contentComponent: LevelContent,
  ebookComponent: ReaderHome,
  noteComponent: MyNotes,
  //glossarry: Glossary
  packageComponent: Packages,

   tabs: [
    { label: "videoCourses", path: "/videos" },
    { label: "ebooks", path: "/docs" },
    { label: "notes", path: "/notes" },
    { label: "tools", path: "/utils" },
    { label: "glossary", path: "/utils/glossary" },
  ]
  
};
